import * as api from "./api";

const clinicalTests = {
  groups: [
    {
      name: "Patients",
      tests: [
        {
          name: "Patient List Search",
          description: "List.Search STU3",
          status: "Ready",
          parameters: [
            { title: "code", value: "patientlist" },
            { title: "identifier", value: "systemlist|5332" },
          ],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/List?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Patient Search",
          status: "Ready",
          parameters: [{ title: "_id", value: "et3PZ7IAOT0bMlZB7.XAbMA3" }],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/Patient?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Patient Get",
          status: "Ready",
          parameters: [{ title: "id", value: "et3PZ7IAOT0bMlZB7.XAbMA3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Patient/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
      ],
    },
    {
      name: "Detection",
      tests: [
        {
          name: "ServiceRequest Search",
          description: "Orders and Referrals",
          status: "Ready",
          parameters: [{ title: "patient", value: "et3PZ7IAOT0bMlZB7.XAbMA3" }],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/ServiceRequest?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "ServiceRequest Read",
          status: "Ready",
          parameters: [{ title: "id", value: "edgAKpPbXED.Ii1PSwY.byRssPMJnIK0pDI2RfbjbEuc3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/ServiceRequest/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "DocumentReference Search (notes)",
          description: "Notes",
          status: "Ready",
          parameters: [
            { title: "patient", value: "et3PZ7IAOT0bMlZB7.XAbMA3" },
            { title: "category", value: "clinical-note" },
            // { title: "_count", value: "3" },
          ],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/DocumentReference?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "DocumentReference Search (Correspondences)",
          description: "Correspondences",
          status: "Ready",
          parameters: [
            { title: "patient", value: "e63wRTbPfr1p8UW81d8Seiw3" },
            { title: "category", value: "correspondence" },
            // { title: "_count", value: "3" },
          ],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/DocumentReference?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "DocumentReference.Read (notes)",
          description: "Notes",
          status: "Ready",
          parameters: [{ title: "id", value: "ezFYYmGQ4gA6mCragNMxUeh1srsomKe6ObiIeOHlfWIo3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/DocumentReference/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "DocumentReference.Read (Correspondences)",
          description: "Correspondences",
          status: "Ready",
          parameters: [{ title: "id", value: "ezFYYmGQ4gA6mCragNMxUeh1srsomKe6ObiIeOHlfWIo3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/DocumentReference/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Procedure.Search (orders)",
          description: "Orders (completed)",
          status: "Ready",
          parameters: [
            { title: "patient", value: "e63wRTbPfr1p8UW81d8Seiw3" },
            // { title: "category", value: "correspondence" },
            // { title: "_count", value: "3" },
          ],
          call: async (integration, parameters) => {
            //patient=ej4nFxzySJAysjMuv4rTBNA3&date=gt2019-01-01&date=lt2019-02-20
            const paramString = parameters ? parameters.join("&") : "";

            const call = `admin/integration/${integration.id}/Procedure?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Procedure.Read (orders)",
          description: "Orders (completed)",
          status: "Ready",
          parameters: [{ title: "id", value: "eoWYdw0W4OEiM8RtzdXhlHnbGVgC1fC.k3fNTZYij4WE3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Procedure/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Procedure.Search (Surgeries)",
          description: "Surgeries",
          status: "Duplicate",
          call: () => {
            return "Not Implemented";
          },
        },
        {
          name: "Procedure.Read (Surgeries)",
          description: "Surgeries",
          status: "Duplicate",
          call: () => {
            return "Not Implemented";
          },
        },
      ],
    },
    {
      name: "Scheduling",
      tests: [
        {
          name: "Appointment Search",
          description: "GetFutureAppointments 2014",
          status: "Ready",
          parameters: [{ title: "patient", value: "et3PZ7IAOT0bMlZB7.XAbMA3" }],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/Appointment?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Encounter Search",
          status: "Ready",
          parameters: [{ title: "patient", value: "et3PZ7IAOT0bMlZB7.XAbMA3" }],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/Encounter?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Encounter Read",
          description: "Encounter.Read",
          status: "Ready",
          parameters: [{ title: "id", value: "erEUj0cIxliR26iK1owjp5g3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Encounter/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "FindAppointment (provider)",
          description: "GetScheduleDaysForProvider2 - Displays open slots/days",
          status: "Ready",
          parameters: [
            { title: "patient", value: "et3PZ7IAOT0bMlZB7.XAbMA3" },
            { title: "provider", value: "E1000" },
          ],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Appointment/$find`;
            return api.post(call, {
              resourceType: "Parameters",
              parameter: [
                {
                  name: "practitioner-reference",
                  valueReference: {
                    reference: "practitioner/" + parameters.find(p => p.includes("provider=")).replace("provider=", ""),
                  },
                },
              ],
            });
          },
        },
        {
          name: "Appointment Create (with insurance)",
          description: "ScheduleAppointmentWithInsurance",
          status: "Not Implemented",
          call: () => {
            return "Not Implemented";
          },
        },
        {
          name: "Appointment Create",
          description: "ScheduleAppointment",
          status: "Not Implemented",
          call: () => {
            return "Not Implemented";
          },
        },
        {
          name: "Appointment Cancel",
          status: "Not Implemented",
          call: () => {
            return "Not Implemented";
          },
        },
      ],
    },
    {
      name: "Administrative",
      tests: [
        {
          name: "Provider Search",
          status: "Ready",
          parameters: [
            { title: "given", value: "marty" },
            { title: "family", value: "seeger" },
          ],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/Practitioner?${paramString}`;
            return api.get(call);
          },
        },
        {
          name: "Location Get",
          description: "Location.Read -Departments",
          status: "Ready",
          parameters: [{ title: "id", value: "e4W4rmGe9QzuGm2Dy4NBqVc0KDe6yGld6HW95UuN-Qd03" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Location/${parameters[0].replace("id=", "")}`;
            return api.get(call);
          },
        },
        {
          name: "Code System",
          description: "GetVisitTypes",
          status: "Not Implemented",
          // status: "Ready",
          parameters: [{ title: "system", value: "visit-type" }],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/CodeSystem?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Binary.Read",
          description: "Practitioner Photo",
          status: "Ready",
          parameters: [{ title: "id", value: "esQeLhUcHfUSQnyrAJ7GV7A3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Binary/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Practitioner.Search",
          status: "Ready",
          parameters: [
            { title: "given", value: "physician" },
            { title: "family", value: "cardiology" },
          ],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/Practitioner?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Practitioner.Read",
          status: "Ready",
          parameters: [{ title: "id", value: "eE6hlSviVSkJZQ.5bZTqYoA3" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Practitioner/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "PractitionerRole.Search",
          status: "Ready",
          parameters: [{ title: "practitioner", value: "eb55Xa5E7EWWnV5eRuWsfKQ3" }],
          call: async (integration, parameters) => {
            const paramString = parameters ? parameters.join("&") : "";
            const call = `admin/integration/${integration.id}/PractitionerRole?${paramString}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "PractitionerRole.Read",
          status: "Ready",
          parameters: [{ title: "id", value: "e1bQiqe39x1frBbdffTdCvPaOxT7lq8Y.Y-JSapHLba03" }],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/PractitionerRole/${parameters[0].replace("id=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
      ],
    },
  ],
};

const smTests = {
  groups: [
    {
      name: "Surveys",
      tests: [
        {
          name: "Get Surveys",
          description: "Get all surveys",
          status: "Ready",

          call: async (integration) => {
            const call = `admin/integration/${integration.id}/Surveys/`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Get Collectors for Survey",
          description: "-",
          status: "Ready",
          parameters: [
            { title: "survey", value: "510029981" },
          ],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/Surveys/${parameters[0].replace("survey=", "")}/Collectors`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Webhooks",
          description: "Get webhooks",
          status: "Ready",
          // status: "Ready",          
          call: async (integration) => {
            const call = `admin/integration/${integration.id}/webhooks`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Send Survey",
          description: "Send a survey to a patient",
          status: "Ready",
          parameters: [
            { title: "survey", value: "510029981" },
            { title: "collector", value: "449199011" },
            { title: "patient", value: "f1de4a24-b800-4f03-9408-f632222a9833" },
          ],
          call: async (integration, parameters) => {
            const url = `admin/integration/${integration.id}/Surveys/${parameters[0].replace("survey=", "")}/Collectors/${parameters[1].replace("collector=", "")}/Send`;
            const response = await api.post(url, {
              patient: parameters[2].replace("patient=", ""),
            });

            return response?.data;
          },
        },

      ],
    },
  ],
};

const startDate = new Date();
startDate.setDate(startDate.getDate() - 7);
const formattedStartDate = startDate.toISOString().slice(0, 19).replace('T', ' ');

const carelonTests = {
  groups: [
    {
      name: "Inbound",
      tests: [
        {
          name: "Sync",
          description: "Sync",
          status: "Ready",
          parameters: [
            { title: "startDate", value: formattedStartDate },
            { title: "dryRun", value: true }
          ],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/sync?startDate=${parameters[0]}&dryRun=${parameters[1]}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
      ],
    },
  ],
};

const zendeskTests = {
  groups: [
    {
      name: "Tickets",
      tests: [
        {
          name: "Get Tickets",
          description: "Get tickets",
          status: "Ready",

          call: async (integration) => {
            const call = `admin/integration/${integration.id}/Tickets/`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Get Ticket Fields",
          description: "Get ticket fields",
          status: "Ready",

          call: async (integration) => {
            const call = `admin/integration/${integration.id}/fields/`;
            const response = await api.get(call);

            return response?.data;
          },
        },
        {
          name: "Search Tickets",
          description: "Search tickets",
          status: "Ready",
          parameters: [
            { title: "query", value: "Tim Test" },
          ],
          call: async (integration, parameters) => {
            const call = `admin/integration/${integration.id}/search?query=${parameters[0].replace("query=", "")}`;
            const response = await api.get(call);

            return response?.data;
          },
        },
      ]
    }
  ]
};

const connectTests = {
  groups: [
    {
      name: "Templates",
      tests: [
        {
          name: "Get Templates",
          description: "Get tickets",
          status: "Ready",

          call: async (integration) => {
            const call = `admin/integration/${integration.id}/templates/`;
            const response = await api.get(call);

            return response?.data;
          },
        },
      ]
    },
    {
      name: "Cases",
      tests: [
        {
          name: "Get Cases",
          description: "Get ticCaseskets",
          status: "Ready",

          call: async (integration) => {
            const call = `admin/integration/${integration.id}/cases/`;
            const response = await api.get(call);

            return response?.data;
          },
        },
      ]
    },
    {
      name: 'Profiles',
      tests: [
        {
          name: 'Get Profiles',
          description: 'Get profiles',
          status: 'Ready',

          call: async (integration) => {
            const call = `admin/integration/${integration.id}/profiles/`;
            const response = await api.get(call);

            return response?.data;
          }
        }
      ]
    }

  ]
};


function getTests(integration) {
  if (integration.type == "SurveyMonkey") return smTests;
  if (integration.type == "Epic")
    return clinicalTests;
  if (integration.type == "Zendesk")
    return zendeskTests;
  if (integration.type == "Amazon-Connect")
    return connectTests;
  if (integration.type == "Carelon")
    return carelonTests;
  return [];
}

export { getTests };
